module.exports = __webpack_public_path__ + "static/media/maska.15f5e1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maska.png
// module id = 158
// module chunks = 0